import React from "react";
import "./styles/CiScrollEvent.scss";
import { useTranslation } from "react-i18next";
const CiScrollEvent = () => {
  const { t } = useTranslation();
  const comment = t("aboutUs.ci.comment", { returnObjects: true }) as string[];
  return (
    <>
      <div className="ci_scroll_event_wrap">
        <div className="inner">
          <div className="left">
            <img src="/imgs/ci_scroll_event.png" alt="" />
          </div>
          <div className="right">
            <div className="logo_wrap">
              <img src="/imgs/letsgo.png" alt="let's go" />
            </div>
            <div className="ment">
              <ul>
                {comment.map((item, i) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CiScrollEvent;
